import React, { useEffect, useState } from 'react'
import styles from "../Corpus/corpus.module.css"
import { axiosInstance } from '../../Helpers/axiosInstance'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomSelect from '../../Components/CustomSelect';

export default function ProfileSettings() {
    const [name, setName] = useState('')
    const [lastName, setLastName] = useState('')
    const [fathersName, setFathersName] = useState('')
    const [position, setPosition] = useState('')
    const [rang, setRang] = useState('')
    const [oldPass, setOldPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [repeat, setRepeat] = useState('')

    const rangList = ["կուրսանտ", "շ-ն", "եֆր․", "կրտ․ ս-տ", "ս-տ", "ավ․ ս-տ", "ավագ", "ենթ․","ավ․ ենթ․", "լ-տ", "ավ․ լ-տ", "կ-ն․", "մ-ր", "փ/գ-տ", "գ-տ", "գեն․ մ-ր", "գեն․ լ-տ", "գեն գ-տ"]

    useEffect(() => {
         (async( ) => {
                 const res = await axiosInstance.get(`/auth/user`)
                 if(res.data.status){
                    console.log(res.data.data)
                     setName(res.data.data.name)
                     setLastName(res.data.data.surname)
                     setFathersName(res.data.data.fathersName)
                     setPosition(res.data.data.position)
                     setRang(res.data.data.rang)
                 }
             })()
    }, [])

    const submitUserData = async () => {
        const res = await axiosInstance.post("/auth/user-data", {name, lastName, fathersName, position, rang})
        if(res.data.status){
            toast.success("Օգտատիրոջ տվյալները հաջողությամբ պահպանվեցին")
        }
    }

    const changePassword = async () => {
        if(!oldPass || !newPass || !repeat){
            toast.error("Լրացրե՛ք գաղտնաբառերի բոլոր դաշտերը")
            return
        }
        if(newPass != repeat){
            toast.error("Գաղտնաբառի կրկնությունը սխալ է");
            return
        }
        const res = await axiosInstance.post("/auth/change-password", {oldPass, newPass})
        if(res.data.status){
            toast.success("Գաղտնաբառը հաջողությամբ փոփոխվեց")
            setOldPass("")
            setNewPass("")
            setRepeat("")
        }else{
            toast.error("Մուտքագրված գաղտնաբառ սխալ է")
        }
    }

  return (
    <div className={styles["profile-info-container"]}>
        <div className={styles["corpus-container"]}>
            <h3 className='text-xl'>Անձնական տվյալներ</h3>
            <div>
                <label htmlFor="corpusName">Անուն</label>
                <input type="text" id="corpusName" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div>
                <label htmlFor="corpusName">Ազգանուն</label>
                <input type="text" id="corpusName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            </div>
            <div>
                <label htmlFor="corpusName">Հայրանուն</label>
                <input type="text" id="corpusName" value={fathersName} onChange={(e) => setFathersName(e.target.value)} />
            </div>
            <div>
                <label htmlFor="corpusName">Պաշտոն</label>
                <input type="text" id="corpusName" value={position} onChange={(e) => setPosition(e.target.value)} />
            </div>
            <div>
                <CustomSelect 
                    defaultValueForInput={rang}
                    options={rangList?.map((el,i) => <option key={i} value={el}>{el}</option>)}
                    callback={setRang}
                    label="Զինկոչում"
                />
            </div>
            <div className=' w-1/5 mx-auto mt-4'>
                <button className='confirm-btn' onClick={() => submitUserData()}>Հաստատել</button>
            </div>
        </div>
        <div className={styles["corpus-container"]}>
            <h3 className='pt-8 text-xl'>Փոխել գաղտնաբառը</h3>
            <div>
                <label htmlFor="corpusName">Հին գաղտնաբառ</label>
                <input type="password" id="corpusName" value={oldPass} onChange={(e) => setOldPass(e.target.value)} />
            </div>
            <div>
                <label htmlFor="corpusName">Նոր գաղտնաբառ</label>
                <input type="password" id="corpusName" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
            </div>
            <div>
                <label htmlFor="corpusName">Կրկնել գաղտնաբառը</label>
                <input type="password" id="corpusName" value={repeat} onChange={(e) => setRepeat(e.target.value)} />
            </div>
            <div className=' w-1/5 mx-auto'>
                <button className='confirm-btn' onClick={() => changePassword()}>Հաստատել</button>
            </div>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
